import { RootState } from '@k2/common/assignments-state/state';
import { getMultipleHhgId } from '@k2/common/shared.module';

export function getAssignmentClientId(assignmentId: number) {
  return (state: RootState) => state.entities.assignments[assignmentId].client;
}

export function getAssignmentHhgs(assignmentId: number) {
  return (state: RootState) => state?.entities?.assignments?.[assignmentId]?.hhgs;
}

export function getHhgFromAssignmentByHhgId(assignmentId: number, hhgId: number) {
  return (state: RootState) => {
    return state?.entities?.assignments?.[assignmentId]?.hhgs
      ?.find(hhg => hhg.id === hhgId);
  };
}

export function getHhgFromAssignmentByAssignmentServiceInstanceId(assignmentId: number, assignmentServiceInstanceId: number) {
  return (state: RootState) => {
    return state?.entities?.assignments?.[assignmentId]?.hhgs
      ?.find(hhg => hhg.assignmentServiceInstance.id === assignmentServiceInstanceId);
  };
}

export function getAssignmentServiceInstanceObjFromHhgId(assignmentId: number, hhgId: number) {
  return (state: RootState) => {
    return state?.entities?.assignments?.[assignmentId]?.hhgs
      ?.find(hhg => hhg.id === hhgId)?.assignmentServiceInstance;
  };
}

export function getAssignmentServiceInstanceIdFromHhgId(assignmentId: number, hhgId: number) {
  return (state: RootState) => {
    return state?.entities?.assignments?.[assignmentId]?.hhgs
      ?.find(hhg => hhg.id === hhgId)?.assignmentServiceInstance.id;
  };
}

export function getAssignmentServiceInstanceIdFromHhgIdForChildServiceStorage(assignmentId: number, hhgId: number) {
  return (state: RootState) => {
    return state?.entities?.assignments?.[assignmentId]?.hhgs
      ?.find(hhg => hhg.id === hhgId)?.assignmentServiceInstance.captiveServices.storage?.assignmentServiceInstance.id;
  };
}

export function getAssignmentServiceInstanceIdFromHhgIdForChildServiceInsurance(assignmentId: number, hhgId: number) {
  return (state: RootState) => {
    return state?.entities?.assignments?.[assignmentId]?.hhgs
      ?.find(hhg => hhg.id === hhgId)?.assignmentServiceInstance.captiveServices.insurance?.assignmentServiceInstance.id;
  };
}

export function getAssignmentServiceInstanceIdFromServiceId(assignmentId: number, serviceId: number) {
  switch (serviceId) {
    // HHG Shipment
    case 26:
      return getAssignmentServiceInstanceIdFromHhgId(assignmentId, getMultipleHhgId());
    // Storage
    case 27:
      return getAssignmentServiceInstanceIdFromHhgIdForChildServiceStorage(assignmentId, getMultipleHhgId());
    // Insurance
    case 28:
      return getAssignmentServiceInstanceIdFromHhgIdForChildServiceInsurance(assignmentId, getMultipleHhgId());
    default:
      return (state: RootState) => {
        return state?.entities?.assignments?.[assignmentId]?.serviceInstances?.[serviceId]?.assignmentServiceInstanceId;
      };
  }
}
